// Per-channel Contactability V2 pills (Phone / Email / SMS)
// Reads phone_status / email_status / sms_status persisted by the
// backend (contactability_v2.py). Never invents a status.
import { Phone, Mail, MessageSquare } from "lucide-react";
import { channelBadge, humanChannelReason } from
  "@/lib/altiora-leads-i18n";

function Pill({ icon: Icon, label, statusObj, testId }) {
  const status = statusObj?.status || "UNKNOWN";
  const badge = channelBadge(status);
  const reason = humanChannelReason(statusObj?.reason);
  const conf = typeof statusObj?.confidence === "number"
    ? Math.round(statusObj.confidence * 100) : null;
  return (
    <div
      data-testid={testId}
      title={`${label} · ${badge.label}${reason ? ` — ${reason}` : ""}${
        conf !== null ? ` · Confiance ${conf}%` : ""}`}
      className="flex items-center gap-1.5 rounded-full px-2 py-1 text-[10px] font-mono uppercase tracking-[0.14em]"
      style={{ background: badge.bg, color: badge.color }}>
      <span aria-hidden
            className="inline-block w-1.5 h-1.5 rounded-full"
            style={{ background: badge.dot }} />
      <Icon className="h-3 w-3" />
      <span>{label}</span>
      <span className="opacity-80">·</span>
      <span>{badge.label}</span>
    </div>
  );
}

export default function ChannelBadges({ record, className = "" }) {
  const phone = record?.phone_status;
  const email = record?.email_status;
  const sms = record?.sms_status;
  // If NONE of the granular statuses exist, this lead has never been
  // enriched → we render nothing and let the parent fall back to the
  // legacy monolithic badge.
  if (!phone && !email && !sms) return null;
  return (
    <div data-testid="channel-badges"
         className={"flex flex-wrap gap-1.5 " + className}>
      <Pill icon={Phone}   label="Tél."   statusObj={phone}
            testId="channel-badge-phone" />
      <Pill icon={Mail}    label="Courriel" statusObj={email}
            testId="channel-badge-email" />
      <Pill icon={MessageSquare} label="SMS" statusObj={sms}
            testId="channel-badge-sms" />
    </div>
  );
}
